// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "" + ({"182": "gsap-vendor","460": "quickjs-sandbox",}[chunkId] || chunkId) + "." + {"182": "07afcecd809afc95","396": "bc30159f92112a27","460": "e273e849e5e2713f","917": "1d09d1de70f344a6","985": "c00634a1c8eda79e",}[chunkId] + ".chunk.js"
}